module.exports = __webpack_public_path__ + "static/gallery-5-97f5524131ebe59bed3daf26e8937630.png";